import { React, PropTypes } from '../dependencies';

import Title from '../Title';
import Text from '../Text';
import CustomFormattedHTMLMessage from '../CustomFormattedHTMLMessage';

const SingleStep = ({ styles, rules, content }) => (
    <div className={styles.container}>
        <Title extend={rules.extendTitle}>
            <CustomFormattedHTMLMessage id={content.title} htmlType="span" />
        </Title>
        {content.description && (
            <Text extend={rules.extendText}>
                <CustomFormattedHTMLMessage id={content.description} htmlType="p" />
            </Text>
        )}
    </div>
);

SingleStep.propTypes = {
    styles: PropTypes.shape().isRequired,
    rules: PropTypes.shape().isRequired,
    content: PropTypes.shape().isRequired,
};

export default SingleStep;
